var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContendZonEone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 297.196,
    height: 32.034,
    viewBox: "0 0 297.196 32.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1219.486 3109.595)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M980.773-1176.238l5.865,10.005,3.105-5.06h17.365l-8.51,15.18h5.865l11.73-20.125Z",
    transform: "translate(-2017.17 -1931.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1016.368-1127.21l-5.642-9.624-2.987,4.867h-16.7l8.186-14.6H993.58L982.3-1127.21Z",
    transform: "translate(-2018.146 -1950.954)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-997.866 -3109.595)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1109.5-1150.975q-3.315,2.643-9.114,2.643t-9.146-2.643a8.589,8.589,0,0,1-3.346-7.11v-12.292a8.612,8.612,0,0,1,3.325-7.111q3.324-2.643,9.125-2.643t9.135,2.643a8.6,8.6,0,0,1,3.335,7.111v12.292A8.622,8.622,0,0,1,1109.5-1150.975Zm-9.145-3.377q5.789,0,5.789-4.048v-11.683q0-4.048-5.747-4.028-5.852,0-5.852,4.028v11.683a3.5,3.5,0,0,0,1.447,2.968A7.266,7.266,0,0,0,1100.355-1154.351Z",
    transform: "translate(-1087.895 1180.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1184.64-1178.323h6.188v30.5h-6.188l-10.488-18.291v18.291h-6.188v-30.5h6.188l10.488,18.375Z",
    transform: "translate(-1139.164 1178.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1262.983-1172.3h-13v6.649h11.285v6.02h-11.285v5.789h13v6.02h-19.675v-30.5h19.675Z",
    transform: "translate(-1187.407 1178.973)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1219.486 -3108.732)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M483.89-1146.561q-5.593,0-8.862-2.611a8.445,8.445,0,0,1-3.269-6.95v-12.049a8.463,8.463,0,0,1,3.238-6.97q3.238-2.591,8.841-2.59t8.821,2.59a8.484,8.484,0,0,1,3.218,6.97v2.693h-6.765v-2.405a3.471,3.471,0,0,0-1.347-2.9,6.2,6.2,0,0,0-3.876-1.048,7.044,7.044,0,0,0-4.153,1.048,3.373,3.373,0,0,0-1.46,2.9v11.452a3.415,3.415,0,0,0,1.439,2.91,6.891,6.891,0,0,0,4.133,1.059,6.293,6.293,0,0,0,3.9-1.049,3.471,3.471,0,0,0,1.367-2.92v-2.385h6.765v2.694a8.484,8.484,0,0,1-3.218,6.97Q489.441-1146.561,483.89-1146.561Z",
    transform: "translate(-471.759 1177.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M569.707-1149.152q-3.249,2.591-8.934,2.591t-8.965-2.591a8.421,8.421,0,0,1-3.28-6.97v-12.049a8.441,8.441,0,0,1,3.259-6.97q3.258-2.591,8.944-2.59t8.955,2.59a8.432,8.432,0,0,1,3.269,6.97v12.049A8.452,8.452,0,0,1,569.707-1149.152Zm-8.965-3.31q5.675,0,5.675-3.969v-11.452q0-3.968-5.634-3.948-5.736,0-5.736,3.948v11.452a3.432,3.432,0,0,0,1.419,2.91A7.123,7.123,0,0,0,560.742-1152.462Z",
    transform: "translate(-520.915 1177.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M643.36-1175.961h6.066v29.9H643.36l-10.28-17.93v17.93h-6.065v-29.9h6.065l10.28,18.012Z",
    transform: "translate(-571.17 1176.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M718.488-1175.961v5.9h-7.957v23.995h-6.518v-23.995h-8.06v-5.9Z",
    transform: "translate(-615.312 1176.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M784.634-1170.06H771.886v6.518h11.062v5.9H771.886v5.675h12.748v5.9H765.348v-29.9h19.286Z",
    transform: "translate(-659.746 1176.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M844.288-1175.961h6.066v29.9h-6.066l-10.28-17.93v17.93h-6.066v-29.9h6.066l10.28,18.012Z",
    transform: "translate(-699.826 1176.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M913.558-1175.961q5.387,0,8.564,2.611a8.542,8.542,0,0,1,3.177,6.95v10.774a8.541,8.541,0,0,1-3.177,6.95,13.009,13.009,0,0,1-8.522,2.611H901.8v-29.9Zm5.223,20.047v-10.2a3.575,3.575,0,0,0-1.265-2.878,5.268,5.268,0,0,0-3.506-1.069h-5.674v18.094h5.634a5.35,5.35,0,0,0,3.526-1.069A3.552,3.552,0,0,0,918.781-1155.914Z",
    transform: "translate(-747.116 1176.598)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContendZonEone);
export default __webpack_public_path__ + "static/media/contendZONEone.af5d5931.svg";
export { ForwardRef as ReactComponent };